export enum PackageStatus {
  DRAFT = 'Draft',
  SAVED = 'Saved',
  QUOTED = 'Quoted',
  REFER_FOR_QUOTE= 'ReferForQuote',
  AUTHORISED_QUOTE = 'AuthorisedQuote',
  PROCEED_TO_PAYMENT= 'ProceedToPayment',
}
